import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  constructor(private loginService: LoginService,private router: Router,public snackBar: MatSnackBar) {
    localStorage.removeItem('username');
    localStorage.removeItem('user_id');
   }
   public loading = false;
  ngOnInit() {
  }


  openSnackBar() {
    this.snackBar.openFromComponent(LoginFailComponent, {
      duration: 3000,
    });
  }

  getUser(token){
      this.loginService.getUser(token).subscribe(data => {
          if (data != null) {
            localStorage.setItem('username', data.user.name);
            localStorage.setItem('email', data.user.username);
            this.router.navigate(['/'+data.module.route]);
          }else{
            this.openSnackBar();
          }
        });
  }

  submit(loginData) {
    this.loading = true;
    this.loginService.login(loginData).subscribe(data => {
      if (data.hasOwnProperty("token")) {
        console.log(data);
        localStorage.setItem('token', data.token);
        this.getUser(data);
      }else{
        this.openSnackBar();
      }
      this.loading = false;
    });
  }
}

@Component({
  selector: 'login-fail',
  templateUrl: 'loginFail.html',
})
export class LoginFailComponent {}
